import {
  PlayerJoinMutation,
  PlayerUpdateSentimentMutation,
  PlayerSubmitDrawingMutation,
  PlayerUpdateQuestionMutation,
  ArtworkReactionCreateMutation,
  ArtworkReactionListQuery
} from '@/API';
import { artworkReactionList } from '@/graphql/queries';
import {
  playerJoin,
  playerUpdateSentiment,
  playerSubmitDrawing,
  playerUpdateQuestion,
  artworkReactionCreate
} from '@/graphql/mutations';
import { generateClient, GraphQLQuery } from 'aws-amplify/api';
import { ReactionType, numberForReactionType } from '@/utils/reactions';

const client = generateClient();

export async function joinSession({
  id,
  name,
  feelingBefore
}: {
  id: string;
  name: string;
  feelingBefore: number;
}) {
  const player = await client.graphql<GraphQLQuery<PlayerJoinMutation>>({
    query: playerJoin,
    authMode: 'none',
    variables: {
      id,
      feelingBefore,
      name
    }
  });

  return player.data?.playerJoin;
}

export async function updateSentiment({
  id,
  playerId,
  sentiment,
  isBefore
}: {
  id: string;
  playerId: string;
  sentiment: number;
  isBefore: boolean;
}) {
  const player = await client.graphql<GraphQLQuery<PlayerUpdateSentimentMutation>>({
    query: playerUpdateSentiment,
    authMode: 'none',
    variables: {
      id,
      playerId,
      sentiment,
      isBefore
    }
  });

  return player.data?.playerUpdateSentiment;
}

export async function updateQuestion({
  id,
  playerId,
  question,
  answer
}: {
  id: string;
  playerId: string;
  question: string;
  answer: boolean;
}) {
  const player = await client.graphql<GraphQLQuery<PlayerUpdateQuestionMutation>>({
    query: playerUpdateQuestion,
    authMode: 'none',
    variables: {
      id,
      playerId,
      question,
      answer
    }
  });

  return player.data?.playerUpdateQuestion;
}

export async function submitDrawing({
  id,
  playerId,
  drawing
}: {
  id: string;
  playerId: string;
  drawing: string;
}) {
  const player = await client.graphql<GraphQLQuery<PlayerSubmitDrawingMutation>>({
    query: playerSubmitDrawing,
    authMode: 'none',
    variables: {
      id,
      playerId,
      drawing
    }
  });

  return player.data?.playerSubmitDrawing;
}

export async function reactToArtwork({
  reaction,
  playerId,
  playerCardId,
  sessionId
}: {
  reaction: ReactionType;
  playerId: string;
  playerCardId: string;
  sessionId: string;
}) {
  const reactionNumber = numberForReactionType(reaction);

  const result = await client.graphql<GraphQLQuery<ArtworkReactionCreateMutation>>({
    query: artworkReactionCreate,
    authMode: 'none',
    variables: {
      input: {
        reaction: reactionNumber,
        playerId,
        playerCardId,
        sessionId
      }
    }
  });

  return result.data?.artworkReactionCreate;
}

export async function getReactions({
  playerId,
  playerCardId,
  sessionId
}: {
  playerId: string;
  playerCardId: string;
  sessionId: string;
}) {
  const result = await client.graphql<GraphQLQuery<ArtworkReactionListQuery>>({
    query: artworkReactionList,
    authMode: 'none',
    variables: {
      filter: {
        playerId,
        playerCardId,
        sessionId
      }
    }
  });

  return result.data?.artworkReactionList;
}
